export default __webpack_public_path__ + "static/media/4.69f55b5c.svg";